<template>
  <div
    style="position:relative;height:100%;"
  >
    <div
        style="padding: 25px;text-align:left;z-index:4;border-bottom: 1px solid rgba(0,0,0,0.1);background:white;"
    >
        <div
            v-if="xcase && xcase.case_type"
            style="display:flex;align-items: center;"
        >
            <div
                v-if="xcase.case_type.icon"
            >
                <img
                    :src="getIconPath(xcase.case_type.id)"
                    style="aspect-ratio: 1/1; max-height: 65px;margin-right: 20px;"
                />
            </div>
            <div
                style="flex-grow: 1;"
            >
                <div
                    style="font-size: 24px;font-weight: bold;"
                >
                    {{ xcase.case_type.name }}
                </div>
                <div
                    v-if="xcase.case_title"
                    style="font-size: 16px;"
                >
                    {{ xcase.case_title }}
                </div>
                <div
                    v-if="xcase.case_number"
                    style="font-size: 16px;"
                >
                    {{ xcase.case_number }}
                </div>
            </div>
        </div>
    </div>
    <div
        class="standard-content"
        :class="{ 'mobile-content': $vuetify.breakpoint.xs}"
        style="padding: 25px;"
    >
        <div>
            <v-layout
                v-if="availableForms.length > 0"
                row
                wrap
            >
                <v-flex
                    v-for="form in availableForms"
                    :key="form.id"
                    xs12
                    sm6
                    md4
                    lg3
                    class="standard-form-card"
                    :class="{ 'mobile-form-card': $vuetify.breakpoint.xs}"
                >
                    <v-card    
                        class="form-card"
                        style="cursor:pointer;"
                        @click="$router.push({ name: 'ClientForm', params: { id: $route.params.id, form_id: form.id } })"
                    >
                        <v-card-text
                            style="border-bottom: 1px solid rgba(0,0,0,0.1);"
                        >
                            <div
                                style="font-size: 16px;font-weight: bold;"
                            >
                                {{form.name}}
                            </div>
                            <div>
                                {{ convertToLocal(form.created_at) }}
                            </div>
                            <br />
                            <span
                                v-if="form.party_name"
                                style="font-weight: bold;"
                            >
                                {{form.party_name}}
                            </span>
                            <span
                                v-if="form.form_number"
                                style="font-style: italic;"
                            >
                                ({{form.form_number}})
                            </span>
                        </v-card-text>
                        <v-card-text
                            v-if="!form.is_new"
                            style="padding-top: 5px;padding-bottom:5px;"
                        >
                            <div
                                style="font-size: 12px;"
                            >
                                <b>Last Updated: </b> {{convertToCalRef(form.updated_at)}}
                            </div>
                        </v-card-text>
                        <v-card-actions
                            style="background: rgba(0,0,0,0.15);border-top: 1px solid rgba(0,0,0,0.1);"
                        >
                            <v-spacer />
                            <v-btn
                                v-if="form.is_signing"
                                color="warning"
                            >
                                Sign Form
                            </v-btn>
                            <v-btn
                                v-else-if="form.is_new"
                                color="green"
                                dark
                            >
                                Start Form
                            </v-btn>
                            <v-btn
                                v-else
                                color="primary"
                            >
                                Open Form
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
            <div
                v-if="availableForms.length == 0"
            >
                <div
                    class="last-message"
                    style="position:relative;margin:auto;margin-top:100px;font-size:24px;vertical-align:middle;text-align:center;opacity:0.3;z-index:0;border-radius: 50%;background-color: rgba(0,0,0,0.06);width:300px;height:300px;"
                >
                    <div
                        style="position:absolute;top:50px;text-align:center;width:100%;"
                    >
                        <v-icon
                            color="262626"
                            size="72"
                        >
                            mdi-tray
                        </v-icon>
                        <br />
                        <span><br /><b>No forms require your attention</b></span>
                    </div>
                </div>
            </div>
        </div>
        <div
            style="margin-top: 20px;"
        >
            <v-expansion-panel
                popout
                style="border-top: 1px solid rgba(0,0,0,0.1);"
            >
                <v-expansion-panel-content
                    style="background: transparent;"
                >
                    <template
                        v-slot:header
                    >
                        <div
                            style="opacity: 0.5"
                        >
                            Submitted Forms
                        </div>
                    </template>
                    <v-card
                        style="padding: 10px;"
                    >
                        <div>
                            <v-layout
                                v-if="unavailableForms.length > 0"
                                row
                                wrap
                            >
                                <v-flex
                                    v-for="form in unavailableForms"
                                    :key="form.id"
                                    xs12
                                    sm6
                                    md4
                                    lg3
                                    class="standard-form-card"
                                    :class="{ 'mobile-form-card': $vuetify.breakpoint.xs}"
                                >
                                    <v-card  
                                        class="form-card"
                                        style="cursor:pointer;"
                                        @click="$router.push({ name: 'ClientForm', params: { id: $route.params.id, form_id: form.id } })"
                                    >
                                        <v-card-text
                                            style="border-bottom: 1px solid rgba(0,0,0,0.1);"
                                        >
                                            <div
                                                style="font-size: 16px;font-weight: bold;"
                                            >
                                                {{form.name}}
                                            </div>
                                            <div>
                                                {{ convertToLocal(form.created_at) }}
                                            </div>
                                            <br />
                                            <span
                                                v-if="form.party_name"
                                                style="font-weight: bold;"
                                            >
                                                {{form.party_name}}
                                            </span>
                                            <span
                                                v-if="form.form_number"
                                                style="font-style: italic;"
                                            >
                                                ({{form.form_number}})
                                            </span>
                                        </v-card-text>
                                        <v-card-text
                                            v-if="!form.is_new"
                                            style="padding-top: 5px;padding-bottom:5px;"
                                        >
                                            <div
                                                style="font-size: 12px;"
                                            >
                                                <b>Last Updated: </b> {{convertToCalRef(form.updated_at)}}
                                            </div>
                                        </v-card-text>
                                        <v-card-actions
                                            style="background: rgba(0,0,0,0.15);border-top: 1px solid rgba(0,0,0,0.1);"
                                        >
                                            <v-spacer />
                                            <v-btn>
                                                View Form
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                            <div
                                v-if="unavailableForms.length == 0"
                            >
                                <div
                                    class="last-message"
                                    style="position:relative;margin:auto;font-size:16px;vertical-align:middle;text-align:center;opacity:0.5;z-index:0;border-radius: 50%;"
                                >
                                    <div
                                        style="text-align:center;width:100%;padding: 20px;"
                                    >
                                        <v-icon
                                            color="262626"
                                            size="72"
                                        >
                                            mdi-tray
                                        </v-icon>
                                        <br />
                                        <span><br /><b>No submitted forms</b></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3

export default {
    name: 'Files',
    data () {
        return {
            xcase: {},
            loading: false
        }
    },
    created () {
        this.fetchForms()
    },
    methods: {

        fetchForms () {
            this.loading = true
            api.userform.contactCases.get(this.$route.params.id)
                .then(data => {
                    this.xcase = data
                    this.loading = false
                })
        },
        getIconPath (id) {
            return api.cases.casetype.icon(id)
        },
    },
    computed: {
        ...mapGetters('userform', [
            'signedForms',
        ]),
        availableForms () {
            var forms = []
            if (!this.loading)
                this.xcase.userforms.filter((form) => {
                    if ((!form.client_readonly || form.is_signing) && !this.signedForms.includes(form.id)) {
                        forms.push(form)
                    }
                })
            return forms
        },
        unavailableForms () {
            var forms = []
            if (!this.loading)
                this.xcase.userforms.filter((form) => {
                    if (form.client_readonly || this.signedForms.includes(form.id)) {
                        forms.push(form)
                    }
                })
            return forms
        }
    }
}
</script>

<style scoped>
    .standard-content {
        max-height: calc(100vh - 93px);
        height:100%;
        overflow-y:auto;
        position: relative;
    }
    .mobile-content {
        max-height: calc(100vh - 93px - 56px) !important;
        position: relative;
    }

    .form-card {
        position: relative;
    }

    .standard-form-card {
        padding-right: 15px;
        padding-top: 15px;
    }

    .mobile-form-card {
        padding-top: 15px;
        padding-right: 0 !important;
    }
</style>